// extracted by mini-css-extract-plugin
export default {"wrapper_0":"_fKSn3km","wrapper_1":"zfri4bp8","img_0":"X_LDYIly","img_1":"n6tvq2if"};